if (!customElements.get('sticky-buy-buttons')) {
  customElements.define(
    'sticky-buy-buttons',
    class StickyBuyButtons extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.trigger = document.querySelector(`#ProductInfo-${this.sectionId} .product-form__buttons`);

        // Nothing to track (buy_buttons block removed from the section): stay hidden.
        if (!this.trigger) return;

        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        // Preorder products render a link instead of a submit button: nothing to proxy or mirror.
        if (this.stickyButton && this.sourceButton) {
          this.stickyButtonText = this.stickyButton.querySelector('span');
          this.stickySpinner = this.stickyButton.querySelector('.loading__spinner');
          this.sourceButtonText = this.sourceButton.querySelector('span');
          this.sourceSpinner = this.sourceButton.querySelector('.loading__spinner');

          if (document.querySelector('cart-drawer')) this.stickyButton.setAttribute('aria-haspopup', 'dialog');

          // Forward to the real submit button so product-form.js handles the add-to-cart.
          this.onStickyClick = this.onStickyClick || (() => this.sourceButton.click());
          this.stickyButton.removeEventListener('click', this.onStickyClick);
          this.stickyButton.addEventListener('click', this.onStickyClick);

          this.mirrorState();
          this.mutationObserver = new MutationObserver(this.mirrorState.bind(this));
          this.mutationObserver.observe(this.sourceButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        this.intersectionObserver = new IntersectionObserver(this.onIntersection.bind(this), { threshold: 0 });
        this.intersectionObserver.observe(this.trigger);

        // JS is running: hand visibility over to CSS.
        this.removeAttribute('hidden');
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      onIntersection([entry]) {
        // Only reveal once the main buttons have scrolled off the top of the viewport,
        // never when they are still below the fold.
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-buy-buttons--visible', shouldShow);
      }

      mirrorState() {
        this.stickyButton.toggleAttribute('disabled', this.sourceButton.hasAttribute('disabled'));
        this.stickyButton.setAttribute('aria-disabled', this.sourceButton.getAttribute('aria-disabled') === 'true');
        this.stickyButton.classList.toggle('loading', this.sourceButton.classList.contains('loading'));

        if (this.stickyButtonText && this.sourceButtonText) {
          this.stickyButtonText.textContent = this.sourceButtonText.textContent;
          this.stickyButtonText.classList.toggle('hidden', this.sourceButtonText.classList.contains('hidden'));
        }

        if (this.stickySpinner && this.sourceSpinner) {
          this.stickySpinner.classList.toggle('hidden', this.sourceSpinner.classList.contains('hidden'));
        }
      }
    }
  );
}
